import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import getGridOptions from './getGridOptions';
import {
  DASHBOARD_METRICS,
  DASHBOARD_OVERVIEW_DATA_LABEL,
  INITIAL_ACTIVE_USERS_FILTERS_VALUES,
} from '../../constants';
import useDashboardFilterFields from '../../hooks/useDashboardFilterFields';
import Table from 'modules/common/Table';
import TPGrid from 'components/TP-UI/TPGrid';
import TPTypography from 'components/TP-UI/TPTypography';
import TPNumberDifference from 'components/TP-UI/TPNumberDifference';

import useStyles from './styles';

const ActiveUsersView = ({ loading, form, items, dataset, onChange }) => {
  const classes = useStyles();
  const fields = useDashboardFilterFields({ form });
  const options = useMemo(() => getGridOptions(loading), [loading]);
  //get last actual active users item
  const lastValue = useMemo(() => items.findLast((item) => item.activeUsers), [items]);
  const firstValue = items[0];

  const filters = useMemo(
    () => ({
      fields: fields,
      form,
      initialValues: INITIAL_ACTIVE_USERS_FILTERS_VALUES,
      maxPrimaryFilters: 4,
    }),
    [form, fields],
  );

  return (
    <Table
      items={items}
      view="custom"
      filters={filters}
      loading={loading}
      onChange={onChange}
      scrollable={false}
      noMatchesText="No active users for this time period"
      hidePagination>
      <TPGrid container direction="column" spacing={2}>
        {lastValue ? (
          <TPGrid item>
            <div className={classes.usersCountContainer}>
              <TPTypography variant="body3" color="secondary">
                {DASHBOARD_OVERVIEW_DATA_LABEL.activeUsers}
              </TPTypography>
              <TPTypography>
                {lastValue[DASHBOARD_METRICS.activeUsers]}(
                <TPNumberDifference
                  value={
                    lastValue[DASHBOARD_METRICS.activeUsers] -
                    firstValue[DASHBOARD_METRICS.activeUsers]
                  }
                  minDigits={0}
                />
                )
              </TPTypography>
            </div>
          </TPGrid>
        ) : null}
        <TPGrid item>
          <Line height={360} data={dataset} options={options} />
        </TPGrid>
      </TPGrid>
    </Table>
  );
};

ActiveUsersView.propTypes = {
  loading: PropTypes.bool,
  form: PropTypes.string.isRequired,
  items: PropTypes.array,
  dataset: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

export default ActiveUsersView;
